import PropTypes from 'prop-types';
import { useLocales } from '../../locales';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { SHORT_ANALYTICS_METRICS_TITLES } from '../../config/constants';
import MetricNotAvailable from "./table";

export const ChartContainer = ({ summary }) => {
  const { translate: t } = useLocales();

  return (
    <div className="w-100 chartContainerWrapper">
      <div className="w-100 px-4 d-flex justify-content-between">
        <div className="dropdown d-none">
          <div
            className="btn btn-secondary dropdown-toggle badge"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          ></div>
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <div className="dropdown-item cursor-pointer">{t('absolute')}</div>
            <div className="dropdown-item cursor-pointer">
              {t('development')}
            </div>
          </div>
        </div>
      </div>
      <Row className="mt-4 px-4 d-flex justify-content-center">
        {SHORT_ANALYTICS_METRICS_TITLES.map((metric) => {
          return (
            <SmallChart
              metric={metric}
              value={summary?.[metric]}
              key={metric}
              showAsPercentage={metric === 'engagement'}
              showTooltip={metric === 'post_performance_rating'}
              toolTipText = {""}
            />
          );
        })}
      </Row>
    </div>
  );
};

ChartContainer.propTypes = {
  summary: PropTypes.any
};

export const SmallChart = ({ metric, value, showAsPercentage = false, showTooltip=false, toolTipText=null }) => {
  const { translate: t } = useLocales();
  
  const chartContent = (
    <div>
      <div className="chartContainer text-center">
        <p className="text-gray-600 fw-bold fs-1 mb-0 fw-bolder" style={{fontSize: "3em"}}>{value ? `${value}${showAsPercentage ? "%": ""}` : <MetricNotAvailable />}</p>
      </div>
      <div className="text-gray-500 fs-8 d-block fw-bold text-center">{t(metric)}</div>
    </div>
  );
  
  return (
    <Col>
      {showTooltip ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip>
              <span className="text-gray-800 fw-bold d-block fs-7 text-start" style={{whiteSpace: "pre-wrap", maxWidth: "250px"}}>
                {toolTipText || t(`${metric}_tooltip`)}
              </span>
            </Tooltip>
          }
        >
          <div>{chartContent}</div>
        </OverlayTrigger>
      ) : (
        chartContent
      )}
    </Col>
  );
};
SmallChart.propTypes = {
  metric: PropTypes.string,
  value: PropTypes.any,
    showAsPercentage: PropTypes.bool,
  showTooltip: PropTypes.bool,
  toolTipText: PropTypes.string
};
